import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import type { ComponentProps } from 'react';
import { memo, useRef } from 'react';

import type { BackLinkOptions } from './types';
import { handleGoBack, shouldHideBackLink } from './utils';

import { usePkTheme } from '@hooks/usePkTheme';
import { useTranslateFn } from '@shared/Translate';

import './styles.scss';

const trackingData = {
  category: 'Click',
  action: 'Go back',
  label: 'navigation',
} as const;

const BackLink = ({
  appearance = 'text',
  highContrast = true,
  className,
  options,
}: {
  appearance?: ComponentProps<typeof PkButton>['appearance'];
  highContrast?: boolean;
  className?: string;
  options?: BackLinkOptions;
}) => {
  const t = useTranslateFn();
  const btnRef = useRef<HTMLPkButtonElement>(null);
  const currentTheme = usePkTheme(btnRef);
  const label = options?.linkLabel ?? 'go_back';

  // do not print button if referrer is internal
  if (shouldHideBackLink(options)) return null;

  const handlePkClick = async () => {
    // need to do that, or the async function don't work properly
    await handleGoBack(options?.isStory, options?.customUrl);
  };
  return (
    <PkButton
      ref={btnRef}
      onPkClick={handlePkClick}
      appearance={appearance}
      ariaLabel={t(label)}
      highContrast={highContrast && currentTheme === 'dark'}
      className={clsx('js-tracking-link', className)}
      data-tracking={JSON.stringify(trackingData)}
      width='auto'
    >
      <PkIcon name='navigation-chevron-left' />
      {t(label)}
    </PkButton>
  );
};

export default memo(BackLink);
